import { CoinType, CurrencyOptions } from '../models';

export const usdFormatting: CurrencyOptions = {
  symbol: '$',
  code: 'USD',
  decimals: 2,
  locale: 'en-US',
  type: CoinType.Fiat,
};
